import axios from 'axios';
import { toast } from 'react-toastify';
import { getApiURL, log } from './config';

// Use environment-based API URL
export let apiURL = getApiURL();

// Log current environment and API URL
log(`API URL configured: ${apiURL}`, 'info');

export async function Post(url, data) {
  try {
    // Check if data is FormData to set proper headers
    const isFormData = data instanceof FormData;
    const headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') };
    
    // Don't set Content-Type for FormData - let browser set it with boundary
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }
    
    const response = await axios({ 
      method: 'POST', 
      url: url, 
      data: data, 
      headers: headers,
      ...(isFormData && { maxContentLength: Infinity, maxBodyLength: Infinity }) // Allow large file uploads
    })
    return response
  }
  catch (error) {
    console.log(error)
    const err = error
    if (err.response) {
      if (err.response.status < 200 || err.response.status >= 300) {
        console.log(err.response.status)

        if (err.response.status === 403) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user_details');
          console.log(error)
        }
        else if (err.response.status === 413) {

          console.log(err)
          toast.error('File Upload Too large Plase Try Again')
        }
        else {
          console.log(error,"knknjknknkj")
        }
      }
    }
    else {
      console.log(error,"knknjknknkj")
    }
    return null
  }
};

export async function Get(url, id) {
  try {
    const response = await axios({ 
      method: 'GET', 
      url: url + (id || ''), 
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      timeout: 30000 // 30 second timeout to prevent hanging
    })
    return response
  }
  catch (error) {
    console.log(error)
    const err = error
    console.log(err)
    if (err.response) {
      if (err.response.status < 200 || err.response.status >= 300) {
        console.log(err.response.status)
        if (err.response.status === 403) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user_details');
          console.log(error)
        }
        else {
          console.log(error)
        }
      }
    }
    else if (err.code === 'ECONNABORTED') {
      console.log('Request timeout - API call took too long')
    }
    else {
      console.log(error)
    }
    return null
  }
};

export async function GetAll(url) {
  try {
    const response = await axios({ 
      method: 'GET', 
      url: url, 
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      timeout: 30000 // 30 second timeout to prevent hanging
    })
    return response
  }
  catch (error) {
    console.log(error)
    const err = error
    if (err.response) {
      console.log(err.response.status)
      if (err.response.status < 200 || err.response.status >= 300) {
        if (err.response.status === 403) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user_details');
          console.log(error)
        }
        else {
          console.log(error)
        }
      }
    }
    else if (err.code === 'ECONNABORTED') {
      console.log('Request timeout - API call took too long')
    }
    else {
      console.log(error)
    }
    return null
  }
};

export async function Put(url, id, data) {
  try {
    const response = await axios({ 
      method: 'PUT', 
      url: url + (id || ''), 
      data: data, 
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      timeout: 30000 // 30 second timeout to prevent hanging
    })
    return response
  }
  catch (error) {
    console.log(error)
    const err = error
    if (err.response) {
      console.log(err.response.status)
      if (err.response.status < 200 || err.response.status >= 300) {
        if (err.response.status === 403) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user_details');
          console.log(error)
        }
        else {
          console.log(error)
        }
      }
    }
    else if (err.code === 'ECONNABORTED') {
      console.log('Request timeout - API call took too long')
    }
    else if (err.code === 'ECONNABORTED') {
      console.log('Request timeout - API call took too long')
    }
    else {
      console.log(error)
    }
    return null
  }
};

export async function Delete(url, id) {
  try {
    const response = await axios({ 
      method: 'DELETE', 
      url: url + (id || ''), 
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
      timeout: 30000 // 30 second timeout to prevent hanging
    })
    return response
  }
  catch (error) {
    console.log(error)
    const err = error
    if (err.response) {
      console.log(err.response.status)
      if (err.response.status < 200 || err.response.status >= 300) {
        if (err.response.status === 403) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user_details');
          console.log(error)
        }
        else {
          console.log(error)
        }
      }
    }
    else if (err.code === 'ECONNABORTED') {
      console.log('Request timeout - API call took too long')
    }
    else {
      console.log(error)
    }
    return null
  }
};
